
import { defineComponent, PropType } from 'vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { getThumbnailUrl } from '@helpers/DiagramHelper'
import { mapActions } from 'vuex'
import DiagramLikeBtn from '~/components/diagram/DiagramLikeBtn.vue'
import DiagramForkBtn from '~/components/diagram/DiagramForkBtn.vue'
import ProfileAvatar from '~/components/profile/ProfileAvatar.vue'
import AppActions from '@constants/AppActions'
import { Block } from '~/domain/interfaces/BlockTypes'
import { Diagram, DiagramsFileKey } from '~/domain/interfaces'

export default defineComponent({
  name: 'CommonInteractiveDiagram',
  components: { ProfileAvatar, DiagramForkBtn, DiagramLikeBtn },
  extends: MachinationsLightPage,
  props: {
    block: {
      type: Object as PropType<Block>,
    },
  },
  data() {
    return {
      diagram: [] as Diagram[],
      tooltipLikeText: 'Like',
    }
  },

  mounted() {
    const observer = new IntersectionObserver(
      async (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            await this.fetchDiagram()
            observer.unobserve(entry.target)
          }
        }
      },
      {
        rootMargin: '0px',
        threshold: 0.1,
      }
    )
    this.$nextTick(() => {
      if (this.$refs.diagramContainer) {
        //@ts-ignore
        observer.observe(this.$refs.diagramContainer)
      }
    })
    if (this.diagram[0]) {
      this.setTooltipValue(
        this.diagram[0].likedByAuthenticatedUser
          ? `${this.$t('wordUnlikeCapital')}`
          : `${this.$t('wordLikeCapital')}`
      )
    }
  },
  computed: {
    displayedDiagram(): Diagram[] {
      return this.diagram
    },
    diagramThumbnailUrl(): string {
      return this.$config.apiBaseURL + getThumbnailUrl(this.diagram[0])
    },
  },
  methods: {
    getDiagramsByFileKey: {} as DiagramsFileKey,
    ...mapActions('diagrams', ['getDiagramsByFileKey']),
    async fetchDiagram() {
      const diagramFuid = this.block?.diagramFuid
      const params = {
        fileKeys: [diagramFuid],
      }
      this.diagram = await this.getDiagramsByFileKey({
        context: this.$nuxt.context,
        params,
      })
    },
    setTooltipValue(value: string): void {
      this.tooltipLikeText = value
    },
    forkDiagramPressed(): void {
      if (this.isAuthenticated) {
        this.$store.dispatch(AppActions.TRACK_SEGMENT_EVENT, {
          context: this,
          params: {
            name: 'Glossary - Fork',
            category: 'Community',
            action: 'Fork',
            label: 'Glossary - Fork',
            misc: [
              {
                diagramName: this.displayedDiagram[0]?.name,
                diagramFuid: this.displayedDiagram[0]?.fuid,
                username: this.$store.$auth.$state.user.username,
              },
            ],
          },
        })
      }
    },
    sanitizeDiagramName(diagramName: string | undefined): string {
      return (
        diagramName
          ?.toLowerCase()
          .replace(/[^a-z\d\s-]+/g, '')
          .replace(/\s+/g, '-') || ''
      )
    },
    getDateFromNow() {
      if (this.displayedDiagram[0])
        return this.$formatters.formatDateDiff(
          this.displayedDiagram[0].lastEdit
        )
      else return ''
    },
    diagramActionTSE(): void {
      if (this.isAuthenticated) {
        this.$store.dispatch(AppActions.TRACK_SEGMENT_EVENT, {
          context: this,
          params: {
            name: this.displayedDiagram[0]?.likedByAuthenticatedUser
              ? 'Glossary - unlike'
              : 'Glossary - like',
            category: 'Community',
            action: this.displayedDiagram[0]?.likedByAuthenticatedUser
              ? 'unlike'
              : 'like',
            label: this.displayedDiagram[0]?.likedByAuthenticatedUser
              ? 'Glossary unlike'
              : 'Glossary like',
            misc: [
              {
                diagramName: this.displayedDiagram[0]?.name,
                diagramFuid: this.displayedDiagram[0]?.fuid,
                username: this.$store.$auth.$state.user.username,
              },
            ],
          },
        })
      }
    },
  },
  created() {
    if (this.block?.diagramFuid) {
      // this.fetchDiagram()
    }
  },
})
